<!--
name:  Global.vue
func:  存储系统 全局变量 和 全局函数

-->
<script>
  export default {
    name: "global",
    currentMapObj:null,//地图对象
    colose:function(){
    }
  }
</script>


// WEBPACK FOOTER //
// src/assets/util/Global.vue